import { useState } from "react";
import { LuX } from "react-icons/lu";
import { TERMINAL_ADMISSION_STATUSES } from "../../utils";

const CommentsSection = ({ admissionSelected, onAdmissionChange }) => {
  const [newComment, setNewComment] = useState("");
  const [editingIndex, setEditingIndex] = useState(-1);
  const [editingText, setEditingText] = useState("");

  const comments = admissionSelected?.comments || [];
  const isLocked = TERMINAL_ADMISSION_STATUSES.includes(admissionSelected?.status);

  const addComment = () => {
    const text = newComment.trim();
    if (!text) return;
    const comment = { text, createdAt: new Date().toISOString() };
    onAdmissionChange([{ field: "comments", value: [...(admissionSelected.comments || []), comment] }]);
    setNewComment("");
  };

  const startEdit = (idx) => {
    if (isLocked) return;
    setEditingIndex(idx);
    setEditingText(comments[idx].text);
  };

  const saveEdit = () => {
    const text = editingText.trim();
    if (!text) return cancelEdit();
    const newCommentsArray = admissionSelected.comments.map((comment, idx) => (idx === editingIndex ? { ...comment, text } : comment));
    onAdmissionChange([{ field: "comments", value: newCommentsArray }]);
    cancelEdit();
  };

  const cancelEdit = () => {
    setEditingIndex(-1);
    setEditingText("");
  };

  const deleteComment = (idx) => {
    onAdmissionChange([{ field: "comments", value: admissionSelected.comments.filter((_, i) => i !== idx) }]);
  };

  const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
  };

  return (
    <div className="mb-4">
      <h3 className="section-title mb-2">
        <span>Commentaires</span>
        {comments.length > 0 && <span className="meta-badge bg-gray-100 text-gray-500">{comments.length}</span>}
      </h3>

      {comments.length > 0 && (
        <div className="mb-3 flex flex-col gap-2">
          {comments.map((c, idx) => (
            <div
              key={idx}
              className="group flex items-start gap-3 card px-3 py-2 transition-colors hover:border-gray-200"
            >
              {editingIndex === idx ? (
                <textarea
                  autoFocus
                  className="flex-grow resize-none border-none bg-transparent text-sm text-gray-900 outline-none"
                  rows={2}
                  value={editingText}
                  onChange={(e) => setEditingText(e.target.value)}
                  onBlur={saveEdit}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      saveEdit();
                    }
                    if (e.key === "Escape") cancelEdit();
                  }}
                />
              ) : (
                <div className="flex min-w-0 flex-1 flex-col">
                  <span className={`${isLocked ? "" : "cursor-text"} whitespace-pre-wrap break-words text-sm text-gray-900`} onClick={() => startEdit(idx)}>
                    {c.text}
                  </span>
                  <span className="mt-1 text-[11px] text-gray-400">{formatDate(c.createdAt)}</span>
                </div>
              )}
              {!isLocked && (
                <button
                  type="button"
                  className="shrink-0 rounded p-1 text-gray-300 opacity-0 transition-all hover:bg-red-50 hover:text-red-500 group-hover:opacity-100"
                  onClick={() => deleteComment(idx)}
                  title="Supprimer"
                >
                  <LuX className="h-3.5 w-3.5" />
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      {!isLocked && (
        <div className="flex items-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-1.5 transition-colors focus-within:border-primary-500 focus-within:ring-2 focus-within:ring-primary-500/20">
          <input
            className="flex-grow bg-transparent text-sm text-gray-900 outline-none placeholder:text-gray-400"
            placeholder="Ajouter un commentaire..."
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") addComment();
            }}
          />
          <button
            type="button"
            className="rounded-md bg-primary-500 px-3 py-1 text-xs font-medium text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400"
            disabled={!newComment.trim()}
            onClick={addComment}
          >
            Ajouter
          </button>
        </div>
      )}
    </div>
  );
};

export default CommentsSection;
